import { defineStore } from 'pinia'

export const usePluginOptionsStore = defineStore('pluginOptions', {
  state: () => ({
    atts: {} as any,
    pluginOption: {} as any,
    // API methods that were previously on rootState
    findAll: () => Promise.resolve([] as any),
    findOne: () => Promise.resolve({} as any),
    saveAll: () => Promise.resolve([] as any),
    saveOne: () => Promise.resolve({} as any),
  }),
  actions: {
    setOptions(options: any) {
      // Merge options into state
      // We iterate keys to ensure we don't overwrite the entire state object if not intended,
      // but for simplicity, Object.assign is fine if options structure matches.
      Object.assign(this, options)
    }
  }
})
